import { FileTypeEnum } from 'kuaidong-model'
import { AppUtil, RequestTokenQueryKey } from './AppUtil'
import { StringUtil } from './StringUtil'

export const _w = window as any

export async function chooseMessageFile(fileType: FileTypeEnum, target: string, isRedirect = false, scene = '') {
  if (_w.wx) {
    const url = `/pages/upload/upload?type=${fileType}&scene=${scene}&${RequestTokenQueryKey}=${AppUtil.getRequestToken()}&target=${encodeURIComponent(
      target
    )}`

    if (isRedirect) {
      _w.wx.miniProgram.redirectTo({ url })
    } else {
      _w.wx.miniProgram.navigateTo({ url })
    }
  }
}

export async function selectMessageFile(params: {
  fileType: FileTypeEnum
  target: string
  isRedirect: boolean
  scene: string
  id: string
}) {
  const { fileType = FileTypeEnum.Excel, target = '', isRedirect = false, scene = '', id = '' } = params
  if (_w.wx) {
    const url = `/pages/upload/upload?type=${fileType}&id=${id}&scene=${scene}&${RequestTokenQueryKey}=${AppUtil.getRequestToken()}&target=${encodeURIComponent(
      target
    )}`

    if (isRedirect) {
      _w.wx.miniProgram.redirectTo({ url })
    } else {
      _w.wx.miniProgram.navigateTo({ url })
    }
  }
}

export async function navigateToChannelsLiveNotice(id = '') {
  _w.wx.miniProgram.navigateTo({
    url: `/pages/channels/live-notice/index?id=${id}&${RequestTokenQueryKey}=${AppUtil.getRequestToken()}`,
  })
}

export async function navigateToContestUploadHomework(
  fileType: FileTypeEnum,
  target: string,
  isRedirect = false,
  scene = ''
) {
  if (_w.wx) {
    const url = `/pages/uploadproject/baseinfo?type=${fileType}&scene=${scene}&${RequestTokenQueryKey}=${AppUtil.getRequestToken()}&target=${encodeURIComponent(
      target
    )}`

    if (isRedirect) {
      _w.wx.miniProgram.redirectTo({ url })
    } else {
      _w.wx.miniProgram.navigateTo({ url })
    }
  }
}

// 打开小程序drill
export async function openWeappDrill(
  drill: string,
  options: {
    isRedirect?: boolean
    query?: any
  } = {}
) {
  const queryStr = StringUtil.buildQueryString({ drill, ...options.query })
  const url = `/pages/drill/drill?${queryStr}`
  if (options.isRedirect) {
    _w.wx.miniProgram.redirectTo({ url })
  } else {
    // 可以回退到上一页的
    _w.wx.miniProgram.navigateTo({ url })
  }
}

// 直接打开小程序页面
export async function openWeappPage(url: string) {
  _w.wx.miniProgram.navigateTo({ url })
}
